import { z } from "zod";
import { stripSearchParams, type SearchMiddleware } from "@tanstack/react-router";
import { defaultPageSearch, optionalPage, optionalSearch } from "./shared";

const poolSortSchema = z.enum(["createdAt:asc", "createdAt:desc"]);

export const investmentSearchDefaults = {
  ...defaultPageSearch,
};

export const investmentSearchSchema = z.object({
  merchantNameContains: optionalSearch(z.string()),
  sort: optionalSearch(poolSortSchema),
  page: optionalPage,
});

export type InvestmentSearch = z.infer<typeof investmentSearchSchema>;

export const investmentSearchMiddlewares: SearchMiddleware<InvestmentSearch>[] = [
  stripSearchParams(investmentSearchDefaults) as SearchMiddleware<InvestmentSearch>,
];
